

import React, { useEffect, useRef, useState } from "react";

    import {
      Card,
      Button,
      Form,
      ListGroup
    } from "react-bootstrap";
    import { FaPaperPlane, FaArrowDown, FaMicrophone, FaStop } from "react-icons/fa";
    import { FaUserCircle, FaRobot } from "react-icons/fa";
    import { IoSend } from "react-icons/io5";
    import "../css/main.css";

    // ✅ IMPORTANT: Make sure you import the chatIcon here!
    import chatIcon from '../images/Chatbot-Icon.svg';
    import chatpopup from '../images/cvchatpopup.png';

    const Chatbot = ({
  messages,
  botTyping,
  input,
  setInput,
  isAudioRecording,
  toggleAudioRecording,
  recordingDuration,
  showScrollBtn,
  scrollToBottom,
  handleSend,
  messagesContainerRef,
  messagesEndRef,
  handleScroll,
  handleKeyPress,
  handleChatStart
}) => {
  const [open, setOpen] = useState(false);
  const chatWindowRef = useRef(null);
//   const [messages, setMessages] = useState([
//     { sender: "bot", text: "Hello 👋 How may I help you today?" },
//   ]);
//   const [input, setInput] = useState("");

//   const chatWindowRef = useRef(null);
//   const chatLiveRef = useRef(null);

//   // Auto-scroll to bottom when new message added
//   useEffect(() => {
//     if (chatLiveRef.current) {
//       chatLiveRef.current.scrollTop = chatLiveRef.current.scrollHeight;
//     }
//   }, [messages]);

  // Auto focus when opening chatbot
  useEffect(() => {
    if (open && chatWindowRef.current) chatWindowRef.current.focus();
  }, [open]);

//   // Send message handler
//   const sendMessage = () => {
//     if (!input.trim()) return;

//     const userMsg = { sender: "user", text: input };
//     setMessages((prev) => [...prev, userMsg]);
//     setInput("");

//     // Simulated bot reply
//     setTimeout(() => {
//       const botReply = {
//         sender: "bot",
//         text: "Thank you for your message 👌 I will get back to you shortly.",
//       };
//       setMessages((prev) => [...prev, botReply]);
//     }, 800);
//   };

  return (
    <>
      {/* Floating Icon */}
      {!open && (
        // <button
        //   className="chatbot-icon"
        //   aria-label="Open chatbot"
        //   onClick={() => setOpen(true)}
        // >
        //   💬
        // </button>
        <button
  className="chatbot-round-btn"
  aria-label="Open chatbot"
  onClick={() => setOpen(true)}
>
  <img
  src={chatpopup}
      alt="chatbot"
    className="round-avatar"
  />
</button>

      )}

      {/* Chat Window */}
      {open && (
        // <div
        //   className="chatbot-window"
        //   role="dialog"
        //   aria-labelledby="chatTitle"
        //   aria-modal="true"
        //   ref={chatWindowRef}
        //   tabIndex={-1}
        // >
        //   <div className="chatbot-header">
        //     <h2 className="visually-hidden" id="chatTitle">
        //       Virtual Assistant Chat
        //     </h2>

        //     <span>Virtual Assistant</span>

        //     <button
        //       className="chatbot-close"
        //       aria-label="Close chat"
        //       onClick={() => setOpen(false)}
        //     >
        //       ✖
        //     </button>
        //   </div>

        //   <div className="chatbot-body" ref={chatLiveRef} aria-live="polite">
        //     {messages.map((msg, index) => (
        //       <div key={index} className={`msg ${msg.sender}`}>
        //         {msg.text}
        //       </div>
        //     ))}
        //   </div>

        //   <div className="chatbot-footer">
        //     <label htmlFor="chatInput" className="visually-hidden">
        //       Type your message and press Enter
        //     </label>

        //     <input
        //       id="chatInput"
        //       type="text"
        //       placeholder="Type your message..."
        //       className="chat-input"
        //       aria-label="Chat message input"
        //       value={input}
        //       onChange={(e) => setInput(e.target.value)}
        //       onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        //     />

        //     <button className="send-btn" aria-label="Send message" onClick={sendMessage}>
        //       ➤
        //     </button>
        //   </div>
          
        // </div>

 <Card className="chatbot-window"   
    role="dialog"
          aria-labelledby="chatTitle"
          aria-modal="true"
          ref={chatWindowRef}
          tabIndex={-1}>

            
      {/* Header */}
      <div className="chat-headerdiv">
        <div className="chat-imgdiv">
          <span className="chat-img-span">
            <img className="chat-image"
              src={chatIcon}
              alt="Chat Icon" />
          </span>
          <span className="chat-header" id="chatTitle">
  Chat with us
</span>

        </div>
        {/* <i className="bi bi-three-dots-vertical"></i> */}
        
         <button
              className="chatbot-close"
              aria-label="Close chat"
              onClick={() => setOpen(false)}
             >



             {/* ? */}
<i class="bi-dash-lg"></i>
             </button>
      </div>



      {/* Chat area */}
      <div
        className="d-flex flex-column"
        style={{
          height: "100%",
          border: "1px solid #ddd",
         
          overflow: "hidden",
        }}
      >
        {/* Chat messages area */}
        <div
          ref={messagesContainerRef}
           role="log"
  aria-live="polite"
  aria-relevant="additions"
  aria-label="Chat messages"
          style={{
            flexGrow: 1,
            height: "320px",
            backgroundColor: "#f9f9f9",
            overflowY: "auto",
            padding: "10px 15px",
          }}
        >

          {messages.map((msg, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent:
                  msg.sender === "user" ? "flex-end" : "flex-start",
                marginBottom: "12px",
                gap: "8px",
              }}
            >
              {/* Bot Message */}
              {msg.sender === "bot" && (
                <>
                  {/* Bot Icon */}
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "#fce4ec",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <FaRobot style={{ color: "#B0004E", fontSize: "22px" }} />
                  </div>

                  {/* Bot Message + Audio */}
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "15px 15px 15px 0",
                      padding: "10px 14px",
                      color: "#000",
                      maxWidth: "70%",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "6px",
                    }}
                  >
                    {msg.text && <div aria-label={`${msg.sender === "bot" ? "Bot says" : "You say"}: ${msg.text}`}>
  {msg.text}
</div>}
                    {msg.audio_url && (
                      <audio
                        controls
                        src={msg.audio_url}
                          aria-label={`${msg.sender === "bot" ? "Bot" : "User"} audio message`}

                        style={{
                          width: "140px",
                          height: "28px",
                          borderRadius: "20px",
                          backgroundColor: "#f8f8f8",
                          border: "1px solid #ddd",
                          outline: "none",
                        }}
                      />
                    )}
                  </div>
                </>
              )}

              {/* User Message */}
              {msg.sender === "user" && (
                <>
                  {/* User Message + Audio */}
                  <div
                    style={{
                      backgroundColor: "#f0f0f0",
                      borderRadius: "15px 15px 0 15px",
                      padding: "10px 14px",
                      color: "#000",
                      maxWidth: "70%",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "6px",
                    }}
                  >
                    {/* {msg.text && <div>{msg.text}</div>} */}
                    <div aria-label={`${msg.sender === "bot" ? "Bot says" : "You say"}: ${msg.text}`}>
  {msg.text}
</div>

                    {msg.audio_url && (
                      <audio
                        controls
                        src={msg.audio_url}
                        style={{
                          width: "140px",
                          height: "28px",
                          borderRadius: "20px",
                          backgroundColor: "#f8f8f8",
                          border: "1px solid #ddd",
                          outline: "none",
                        }}
                      />
                    )}
                  </div>

                  {/* User Icon */}
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "#B0004E",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <FaUserCircle style={{ color: "#fff", fontSize: "22px" }} />
                  </div>
                </>
              )}
            </div>
          ))}



          {botTyping && (
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                marginBottom: "12px",
                gap: "8px",
              }}
            >
              {/* Bot Icon */}
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#fce4ec",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaRobot style={{ color: "#B0004E", fontSize: "22px" }} />
              </div>

              {/* Typing Bubble */}
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "15px 15px 15px 0",
                  padding: "10px 14px",
                  color: "#555",
                  fontStyle: "italic",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  display: "inline-block",
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="typing-dots d-flex gap-1">
                    <span className="dot" />
                    <span className="dot" />
                    <span className="dot" />
                  </div>
                  {/* <span className="ms-2">Typing...</span> */}
                  <span className="ms-2" aria-live="polite">
  Bot is typing
</span>

                </div>
              </div>
            </div>
          )}


          <div ref={messagesEndRef} />
        </div>

        {/* Input area */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            borderTop: "1px solid #ddd",
            padding: "10px",
            backgroundColor: "#fff",
          }}
        >
          <Form.Control
            as="textarea"
            placeholder="Type here or use the mic..."
            aria-label="Type your message"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            onFocus={handleChatStart}
            onInput={handleChatStart}
            style={{
              borderRadius: "20px",
              border: "1px solid #ccc",
              flexGrow: 1,
              paddingLeft: "15px",
              resize: "none",
              minHeight: "38px",
              maxHeight: "120px",
            }}
          />


          {input.trim() ? (
            <Button
              onClick={handleSend} className="send-btn" aria-label="Send message"

            >
              <IoSend color="#B0004E" size={22} />

            </Button>



          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginLeft: "10px",
              }}
            >
              {isAudioRecording ? (
                <>
                  <FaStop
                   role="button"
  tabIndex={0}
  aria-label="Stop recording"
                    onClick={toggleAudioRecording}
                      onKeyDown={(e) => e.key === "Enter" && toggleAudioRecording()}

                    style={{
                      color: "#eb1f1f",
                      fontSize: "28px",
                      cursor: "pointer",
                      animation: "pulse 1s infinite",
                    }}
                    title="Stop Recording"
                  />

                  <span
                    style={{
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    {recordingDuration}
                  </span>
                </>
              ) : (
                <FaMicrophone
                 role="button"
  tabIndex={0}
  aria-label="Start voice recording"
                  onClick={toggleAudioRecording}
                    onKeyDown={(e) => e.key === "Enter" && toggleAudioRecording()}

                  style={{
                    color: "#B0004E",
                    fontSize: "28px",
                    cursor: "pointer",
                  }}
                  title="Start Recording"
                />




              )}
            </div>
          )}
        </div>
        
      </div>
    </Card>
    )}
    </>
  );
};

export default Chatbot;
